import React from "react";
import css from "../lstd/index.css";
import getSize from "../../../utils/getSize";
import NHTable from "../../common/NHTable";
import {Button} from 'antd';

class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    //导出
    handleExportBtnClick = (tar) => {
        tar.exportExcel('绿色通道明细数据');
    };

    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '60px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType: "input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100px',
                searchType: "input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '70px',
                searchType: "select"
            }, {
                title: '学院',
                dataIndex: 'BMMC',
                width: '100px',
                searchType: "select"
            }, {
                title: '专业',
                dataIndex: 'ZYMC',
                width: '100px',
                searchType: "select",
                parentField: "BMMC"
            }, {
                title: '班级',
                dataIndex: 'BJMC',
                width: '100px',
                searchType: "select",
                parentField: "ZYMC"
            }, {
                title: '所属年级',
                dataIndex: 'SSNJ',
                width: '100px',
                searchType: "select"
            }, {
                title: '缓交学费住宿费',
                dataIndex: 'HJXFZSFJE',
                width: '140px'
            }, {
                title: '生活补贴',
                dataIndex: 'SHBTJE',
                width: '100px'
            }, {
                title: '生活用品',
                dataIndex: 'SHYPJE',
                width: '100px'
            }, {
                title: '路费补助',
                dataIndex: 'LFBZJE',
                width: '100px'
            }, {
                title: '其他补助',
                dataIndex: 'QTBZJE',
                width: '100px'
            }, {
                title: '生源地贷款',
                dataIndex: 'SYDDKJE',
                width: '120px'
            },/*  {
                title: '高校贷款',
                dataIndex: 'GXDKJE',
                width: '100px'
            } */
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 123}}>
                <div className={css.table}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.PKID}
                             sign={"zhxg_yxfw_swbl_lstdmx"}
                             columns={columns}
                             rangeFilter={true}
                    >
                        <Button type="primary" style={{marginLeft: 10}}
                                onClick={() => this.handleExportBtnClick(this.refs.nhTable)}>导出</Button>
                    </NHTable>
                </div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./components/swbl/lstdmx/index.js